import { createStyles, makeStyles } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import TextFieldPreview from '@sprinx/react-mui-fields/TextFieldPreview';
import React from 'react';
import { CatalogueProduct } from '../../../api/products/catalogue';

export interface CataloguePageListContentItemCardPackageInfoProps
  extends StandardDivProps<CataloguePageListContentItemCardPackageInfoClassKey> {
  // Add more prop definitions here...
  product: CatalogueProduct;
}

export type CataloguePageListContentItemCardPackageInfoClassKey = 'root' | 'packageInfo' | 'packageField';

const themeSettings = { name: 'CataloguePageListContentItemCardPackageInfo' };
const useStyles = makeStyles(
  createStyles<CataloguePageListContentItemCardPackageInfoClassKey, {}>({
    root: {},
    packageInfo: {
      position: 'absolute',
      top: '0',
      right: '0',
      width: 'auto',
      padding: '1rem',
    },
    packageField: {
      width: 'auto',
    },
  }),
  themeSettings,
);

const CataloguePageListContentItemCardPackageInfo = React.forwardRef<
  HTMLDivElement,
  CataloguePageListContentItemCardPackageInfoProps
>(({ classes: pClasses, product }, ref) => {
  const classes = useStyles({ classes: pClasses });

  return (
    <div ref={ref} className={classes.packageInfo}>
      <TextFieldPreview value={product.extra?.packSizeText || ''} size='small' className={classes.packageField} />
    </div>
  );
});

CataloguePageListContentItemCardPackageInfo.displayName = 'CataloguePageListContentItemCardPackageInfo';

export default withThemeProps(themeSettings)(CataloguePageListContentItemCardPackageInfo);
